import indigo from '@material-ui/core/colors/indigo';

export const themeColor = indigo;